"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Toggle = _ref => {
  let {
    isChecked,
    onChange,
    isDisabled = false
  } = _ref;
  const handle = e => {
    if (isDisabled) return;
    e.preventDefault();
    onChange(!isChecked);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-toggle ".concat(isChecked ? 'checked' : '', " ").concat(isDisabled ? 'disabled' : ''),
    onClick: handle,
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-toggle-cursor"
  }), /*#__PURE__*/_react.default.createElement("input", {
    className: "hpd-toggle-input",
    type: "checkbox",
    checked: isChecked,
    onChange: () => {}
  }));
};
var _default = exports.default = Toggle;